import { View, Text } from "@react-pdf/renderer";
import React from "react";
import { styles } from "./PDFReportCSS";
import { Client } from "../../../_models/Client.model";

interface PDFReportRemarksPageProps {
  ClientRemarks: string;
  CNARemarks: string;
  client:Client
}

export const PDFReportRemarks: React.FC<PDFReportRemarksPageProps> = ({
  ClientRemarks,
  CNARemarks,
  client
}) => {

  return (
    <>
      <View key={"remarksSection"} wrap={false}>
        <View style={{ ...styles.row, marginTop: "20px" }}>
          <View style={{ ...styles.col, width: "100%" }}>
            <Text style={{...styles.secondaryTitles,color:"#000"}}>Client Remarks</Text>
            <Text style={{ ...styles.paragapthText, marginTop: "10px" }}>
              {ClientRemarks}
            </Text>
          </View>
        </View>
        <View style={{ ...styles.row, marginTop: "10px" }}>
          <View style={{ ...styles.col, width: "100%" }}>
            <Text style={{...styles.secondaryTitles,color:"#000"}}>CNA Remarks</Text>
            <Text style={{ ...styles.paragapthText, marginTop: "10px" }}>
              {CNARemarks}
            </Text>
          </View>
        </View>
      </View>
    </>
  );
};

